import {
  Root,
  CollapsibleContent as RadixCollapsibleContent,
} from '@radix-ui/react-collapsible';
import {
  forwardRef,
  type ElementRef,
  type ComponentPropsWithoutRef,
} from 'react';

import { cn } from '@/lib/utils';

const Collapsible = Root;

const CollapsibleContent = forwardRef<
  ElementRef<typeof RadixCollapsibleContent>,
  ComponentPropsWithoutRef<typeof RadixCollapsibleContent>
>(({ className, ...props }, ref) => (
  <RadixCollapsibleContent
    ref={ref}
    className={cn(
      'overflow-hidden', // data-[state=open]:animate-collapsible-down data-[state=closed]:animate-collapsible-up
      className,
    )}
    {...props}
  />
));

CollapsibleContent.displayName = 'CollapsibleContent';

export { Collapsible, CollapsibleContent };
